<div class="adc-popover" *ngIf="type=='message'" ngClass="{{ hoverText.customClass }}">
    <button class="adc-btn adc-btn-primary">Hover</button>
    <span style="margin-left: -70px;">{{ hoverText.content }}</span>
</div>

<div class="adc-popover" *ngIf="type=='title'" ngClass="{{ hoverText.customClass }}" (mouseover)="onMouseOver($event)" (mouseout)="onMouseOut()">
    <button class="adc-btn adc-btn-primary">Hover</button>
    <span class="adc-popovertext" [style.display]="isPopoverVisible ? 'block' : 'none'">
      <header>{{ hoverText.header }}</header>
      <p>{{ hoverText.content }}</p>
    </span>
</div>

<div class="adc-popover" *ngIf="type=='button'" ngClass="{{ hoverText.customClass }}">
    <button class="adc-btn adc-btn-primary">Hover</button>
    <span class="adc-popovertext">
        <header>{{ hoverText.header }}</header>
        <p>{{ hoverText.content }}</p>
        <div>
            <button class="adc-btn adc-btn-sm adc-btn-primary" *ngFor="let i of hoverText.button" (click)="actionEvent(i)">{{ i }}</button>
            <!-- <button class="adc-btn adc-btn-primary adc-btn-sm">Next</button> -->
        </div>
    </span>
</div>